// extracted by mini-css-extract-plugin
module.exports = {"formClass":"pc","setupPinButton":"pd","submitButton":"pe","cancelButton":"pf","enterPinHelpText":"ph"};